webpackJsonp([212839066777427],{

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var activeLink = 'home';
	
	var Navigation = function (_Component) {
	  _inherits(Navigation, _Component);
	
	  function Navigation() {
	    _classCallCheck(this, Navigation);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Navigation.prototype.render = function render() {
	
	    return _react2.default.createElement(
	      'nav',
	      { style: {
	          background: '#FF1654'
	        }, className: 'navbar navbar-expand-lg navbar-dark' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { className: 'navbar-brand', to: '/' },
	        'Michael Brooks\' Blog'
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: 'navbar-toggler', type: 'button', 'data-toggle': 'collapse', 'data-target': '#navbarSupportedContent', 'aria-controls': 'navbarSupportedContent', 'aria-expanded': 'false', 'aria-label': 'Toggle navigation' },
	        _react2.default.createElement('span', { className: 'navbar-toggler-icon' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'collapse navbar-collapse', id: 'navbarSupportedContent' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'navbar-nav mr-auto' },
	          _react2.default.createElement(
	            'li',
	            { className: 'nav-item' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { className: 'nav-link', to: '/' },
	              'Home ',
	              _react2.default.createElement(
	                'span',
	                { className: 'sr-only' },
	                '(current)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'nav-item' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { activeClassName: 'active', className: 'nav-link', to: '/blog' },
	              'Blog'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'nav-item' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { activeClassName: 'active', className: 'nav-link', to: '/categories' },
	              'Categories'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Navigation;
	}(_react.Component);
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Navigation = __webpack_require__(39);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	__webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogPage = function BlogPage(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Navigation2.default, null),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      data.allMarkdownRemark.edges.map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          'div',
	          { style: { padding: '15px 0 90px' }, className: 'row', key: node.id },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-sm-12' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: 'post' + node.fields.slug },
	              _react2.default.createElement('img', { src: '/images/' + node.frontmatter.featuredImage }),
	              _react2.default.createElement(
	                'h3',
	                null,
	                node.frontmatter.title,
	                " ",
	                _react2.default.createElement(
	                  'span',
	                  { color: '#BBB' },
	                  '\u2014 ',
	                  node.frontmatter.date
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'post' },
	              _react2.default.createElement(
	                'p',
	                null,
	                node.excerpt,
	                ' ',
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: 'post' + node.fields.slug },
	                  'Read More'
	                )
	              )
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = BlogPage;

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-626737bc4b1b0e013498.js